import { motion } from 'framer-motion';
import { Lightbulb, Eye, Compass } from 'lucide-react';

const gains = [
  {
    icon: Lightbulb,
    title: 'Clarity on Your Strengths',
    description: 'Identify what drives you and how to amplify it.'
  },
  {
    icon: Eye,
    title: 'Awareness of Barriers',
    description: 'Recognize emotional and behavioral patterns holding you back.'
  },
  {
    icon: Compass,
    title: 'Pathway to Success',
    description: 'Develop the traits you need to achieve your goals.'
  }
];

export function GainsSection() {
  return (
    <section id="gains" className="py-20 px-4">
      <div className="w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16 w-full"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            What You'll Gain
          </h2>
          <p className="text-gray-600 text-lg w-full">
            Transform your understanding and unlock your full potential
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 w-full">
          {gains.map((gain, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-3xl shadow-sm border border-gray-200 hover:shadow-md transition-all duration-300 hover:scale-[1.02]"
            >
              <div className={`p-10 text-center h-full min-h-[350px] flex flex-col justify-center ${
                index === 0 ? 'bg-blue-50 border-blue-100' :
                index === 1 ? 'bg-emerald-50 border-emerald-100' :
                'bg-purple-50 border-purple-100'
              } rounded-3xl`}>
                <div className={`inline-flex items-center justify-center w-24 h-24 rounded-full mb-8 mx-auto ${
                  index === 0 ? 'bg-blue-100' :
                  index === 1 ? 'bg-emerald-100' :
                  'bg-purple-100'
                }`}>
                  <gain.icon className={`w-12 h-12 ${
                    index === 0 ? 'text-blue-600' :
                    index === 1 ? 'text-emerald-600' :
                    'text-purple-600'
                  }`} />
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-6">
                  {gain.title}
                </h3>
                <p className="text-xl text-gray-600 leading-relaxed">
                  {gain.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}